import { Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import * as dayjs from 'dayjs';
import { DaterangepickerDirective } from 'ngx-daterangepicker-material';
import { AddressesService } from 'app/home/search-box/service/addresses.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { UserService } from 'app/pages/com.usblick.common/auth/user.service';
import { MaterialModalConfirmComponent } from '../material-modal-confirm/material-modal-confirm.component';
import { FormOfflineService } from './form-offline.service';
import { HttpErrorResponse } from '@angular/common/http';
import { BedType, BoardType, CategoryType, RommType, TimeDay, TransmissionType, TypeTransfer, VehicleTypes, VehicleTypesCar } from './models';
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment';
import { NotificationService } from '../notifications/notification.service';
@Component({
  selector: 'usb-form-offline',
  templateUrl: './form-offline.component.html',
  styleUrls: ['./form-offline.component.scss'],
  providers: [AddressesService]
})
export class FormOfflineComponent implements OnInit {
  @Input() clientSetting: any;
  @ViewChild(DaterangepickerDirective) picker!: DaterangepickerDirective;
  @ViewChild("destination") myInputField: ElementRef;
  @ViewChild('autocompleteInput') autocompleteInput!: ElementRef;
  tab: string = "hotel";
  formHotel: FormGroup;
  formTransfer: FormGroup;
  formRentACar: FormGroup;
  startDate: any;
  dateRange: any = { start: null, end: null };
  minDate: any;
  maxDate: Date;
  max: number;
  rate:number = 0;

  boardType = BoardType;
  roomType = RommType;
  transmissionType = TransmissionType;
  categoryType = CategoryType;
  bedType = BedType;
  typeTransfer = TypeTransfer;
  vehicleTypes = VehicleTypes;
  timeDay = TimeDay;
  vehicleTypesCar = VehicleTypesCar;

  roomsAndPassengers: string;
  originInputValue: string = '';
  pickup: any;
  dropoff: any;
  selectediataCodeDestiny: any;
  selectediataCodeOrigin: any;
  destinationInputValue: any;
  isHoveredCancelDate: boolean;
  isHovered = false;
  mesaggeErrorVisibleOrigin: boolean = false;
  mesaggeErrorVisibleDestination: boolean = false;
  dpConfig: Partial<BsDatepickerConfig> = new BsDatepickerConfig();
  now = new Date();
  currentTime = this.now.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
  oneWay: boolean = true;
  backgroundSelect: any;
  buttonColorActive: any;
  buttonTextActive: any;
  formHotelEdited = false;
  formTransferEdited = false;
  formRentACarEdited = false;
  edit: boolean = false;
  bsConfig: object;
  public editData: any;
private originalPickerPosition = { top: 0, left: 0 };
    constructor(
          @Inject(MAT_DIALOG_DATA) public data: any,
          public dialogRef: MatDialogRef<FormOfflineComponent>,
          private formBuilder: FormBuilder,
          private notificationService: NotificationService,
          private userService: UserService,
          public dialog: MatDialog,
          private formService: FormOfflineService,
          public spinner: NgxSpinnerService,
    ) { this.dpConfig = {
      dateInputFormat: 'DD/MM/YYYY'
    };}

  ngOnInit(): void {
   this.minDate = moment().startOf('day');

    this.clientSetting = this.data?.clientSetting;
    this.edit = this.data?.edit ? true : false;
    this.editData = this.data?.editData;
    const bookingFlow_sidebar = JSON.parse(this.clientSetting?.clients_setting_app_booking?.bookingFlow_sidebar);
    this.backgroundSelect = JSON.parse(this.clientSetting?.clients_setting_app_booking?.bookingFlow_body).card_background_price;
    this.buttonColorActive = bookingFlow_sidebar?.background_color_header;
    this.buttonTextActive = bookingFlow_sidebar?.color;
    if(this.edit && this.editData) {
      this.tabActive(this.editData.category);
      console.log(this.editData.category)
      switch(this.editData.category) {
        case 'hotels':
          this.initFormHotel();
        break;
        case 'transfers':
          this.initFormTransfer();
          break;
        case 'rentacar':
          this.initFormRentACar();
          break;
      }
    }
    if(!this.edit) {
      this.tab = 'hotel';
      this.initFormHotel();
      this.initFormTransfer();
      this.initFormRentACar();
    }
  }

  isInvalidDate = (m: moment.Moment) => {
  return m.isBefore(this.minDate, 'day');
}

  tabActive(tab: string) {
    switch(tab) {
      case 'hotel':
        this.tab = 'hotel';
        break;
      case 'hotels':
        this.tab = 'hotel';
        break;
      case 'transfer':
        this.tab = 'transfer';
        break;
      case 'transfers':
        this.tab = 'transfer';
        break;
      case 'rent-a-car':
        this.tab = 'rent-a-car';
        break;
      case 'rentacar':
        this.tab = 'rent-a-car';
        break;
    }
  }

  initFormHotel(): void {
    this.formHotel = this.formBuilder.group({
      destination:  new FormControl(null, [Validators.required, Validators.minLength(3),Validators.maxLength(80)]),
      arrivalDepartureDate: new FormControl(null, Validators.required),
      hotelsName: new FormControl(null, Validators.maxLength(100)),
      star: new FormArray([], Validators.required),
      zone: new FormControl(null, Validators.maxLength(100)),
      adults: new FormControl(2, [Validators.required, Validators.min(2), Validators.max(99)]),
      childs: new FormControl(0, [Validators.required, Validators.max(99)]),
      age_childs: new FormControl(null),
      qty_rooms: new FormControl(null, [Validators.min(0), Validators.max(99)]),
      price_night: new FormControl(null, Validators.max(99999999)),
      currency: new FormControl(null, Validators.maxLength(12)),
      category: new FormArray([]),
      type_bed: new FormArray([]),
      meals: new FormArray([]),
      roomConfiguration: new FormControl(null),
      nationality: new FormControl(null, [Validators.minLength(3), Validators.maxLength(50)]),
      comment_contact: new FormControl([Validators.minLength(3), Validators.maxLength(500)])
    });

    const initialHotelValue = this.formHotel.getRawValue();

    this.formHotel.valueChanges.subscribe(currentValue => {
      if (JSON.stringify(currentValue) !== JSON.stringify(initialHotelValue)) {
        this.formHotelEdited = true;
      }
    });

    this.formHotel.get('childs').valueChanges.subscribe((value: any) => {
      if(value > 0) {
        this.formHotel.get('age_childs').setValidators(Validators.required);
      } else if (value === 0 || value === '' || value === null) {
         this.formHotel.get('age_childs').clearValidators();
      }
       this.formHotel.get('age_childs').updateValueAndValidity();
    });

    this.formHotel.reset();
    this.formHotelEdited = false;

    if(this.edit && this.editData) {
     this.patchFormHotel(this.editData);
    }

  }

    patchFormHotel(editData: any): void {
      const product = editData?.product || {};
      console.log(product)

      const startDate = product.arrivalDepartureDate?.start
        ? new Date(product.arrivalDepartureDate.start)
        : null;

      const endDate = product.arrivalDepartureDate?.end
        ? new Date(product.arrivalDepartureDate.end)
        : null;

      this.formHotel.patchValue({
        destination: product.destination ?? 'N/A',
        arrivalDepartureDate: startDate && endDate ? { start: startDate, end: endDate } : null,
        hotelsName: product.hotelsName ?? 'N/A',
        zone: product.zone ?? 'N/A',
        adults: product.adults ?? 0,
        childs: product.childs ?? 0,
        age_childs: product.age_childs ?? 'N/A',
        qty_rooms: product.qty_rooms ?? 0,
        price_night: product.price_night ?? 0,
        currency: product.currency ?? 'N/A',
        nationality: product.nationality ?? 'N/A',
        comment_contact: product.comment_contact ?? 'No hay comentarios'
      });

    if(product?.meals && product?.meals.length > 0){
      product.meals.forEach((meal: any) => {
        let event = {
          target: {
          checked: true,
          value: meal
        }}
        this.onChangeSelectForm(event,'hotel', 'meals');
      })
    }

        if(product?.star && product?.star.length > 0){
      product.star.forEach((meal: any) => {
        let event = {
          target: {
          checked: true,
          value: meal
        }}
        this.onChangeSelectForm(event,'hotel', 'star');
      })
    }

        if(product?.category && product?.category.length > 0){
      product.category.forEach((meal: any) => {
        let event = {
          target: {
          checked: true,
          value: meal
        }}
        this.onChangeSelectForm(event,'hotel', 'category');
      })
    }

        if(product?.type_bed && product?.type_bed.length > 0){
      product.type_bed.forEach((meal: any) => {
        let event = {
          target: {
          checked: true,
          value: meal
        }}
        this.onChangeSelectForm(event,'hotel', 'type_bed');
      })
    }

    this.formHotel.disable();


  };

  initFormTransfer(): void {
    this.formTransfer = this.formBuilder.group({
      firstArrivalDate: new FormControl(null, Validators.required),
      secondArrivalDate: new FormControl(null),
      firstTime: new FormControl(null, Validators.required),
      secondTime: new FormControl(null),
      firstOrigin: new FormControl(null, [Validators.required, Validators.minLength(3), Validators.maxLength(50)]),
      firstDestination: new FormControl(null, [Validators.required, Validators.minLength(3), Validators.maxLength(50)]),
      oneWay: new FormControl(null),
      adults: new FormControl(null, [Validators.required, Validators.min(1), Validators.max(99)]),
      childs: new FormControl(null, [ Validators.min(0), Validators.max(99)]),
      age_childs: new FormControl(null),
      qty_bags: new FormControl(null,[Validators.min(0), Validators.max(99)]),
      typeTransfer: new FormArray([]),
      typeVehicle: new FormArray([]),
      comment_contact: new FormControl(null, [Validators.minLength(3), Validators.maxLength(500)])

    })

    const initialTransferValue = this.formTransfer.getRawValue();

    this.formTransfer.valueChanges.subscribe(currentValue => {
      if (JSON.stringify(currentValue) !== JSON.stringify(initialTransferValue)) {
        this.formTransferEdited = true;
      }
    });

    this.formTransfer.get('childs').valueChanges.subscribe((value: any) => {
      if(value > 0) {
        this.formTransfer.get('age_childs').setValidators(Validators.required);
      } else if (value === 0 || value === '' || value === null) {
         this.formTransfer.get('age_childs').clearValidators();
      }
       this.formTransfer.get('age_childs').updateValueAndValidity();
    });

    this.formTransfer.reset();
    this.formTransferEdited = false;

    if(this.edit && this.editData) {
        this.patchFormTransfer(this.editData);
    }
  }

  patchFormTransfer(editData: any): void {
      const product = editData?.product || {};
      console.log(product)

      const firstArrivalDate = product.firstArrivalDate
        ? new Date(product.firstArrivalDate)
        : null;

      const secondArrivalDate = product.secondArrivalDate
        ? new Date(product.secondArrivalDate)
        : null;

        this.formTransfer.patchValue({
        firstArrivalDate: firstArrivalDate ?? null,
        secondArrivalDate: secondArrivalDate ?? null,
        firstTime: product.firstTime ?? null,
        secondTime: product.secondTime ?? null,
        firstOrigin: product.firstOrigin ?? null,
        firstDestination: product.firstDestination ?? null,
        oneWay: product.secondArrivalDate ? true : false,
        adults: product.adults ?? null,
        childs: product.childs ?? null,
        qty_bags: product.qty_bags ?? 'N/A',
        comment_contact: product.comment_contact ?? 'No hay comentarios'

      });

         if(product?.typeTransfer && product?.typeTransfer.length > 0){
            product.typeTransfer.forEach((meal: any) => {
              let event = {
                target: {
                checked: true,
                value: meal
              }}
              this.onChangeSelectForm(event,'transfer', 'typeTransfer');
            })
    }

       if(product?.typeVehicle && product?.typeVehicle.length > 0){
      product.typeVehicle.forEach((meal: any) => {
        let event = {
          target: {
          checked: true,
          value: meal
        }}
        this.onChangeSelectForm(event,'transfer', 'typeVehicle');
      })
    }

      console.log(this.formTransfer)
      this.formTransfer.disable();
  }

  initFormRentACar(): void {
    this.formRentACar = this.formBuilder.group({
      origin: new FormControl(null, [Validators.required, Validators.minLength(3), Validators.maxLength(50)]),
      pickupDate: new FormControl(null, Validators.required),
      pickupTimeDay: new FormArray([], Validators.required),
      destinationReturn: new FormControl(null, [Validators.minLength(3), Validators.maxLength(50)]),
      dropoffDate: new FormControl(null, Validators.required),
      dropoffTimeDay: new FormArray([], Validators.required),
      vehicleType: new FormArray([]),
      transmissionType: new FormArray([]),
      adults: new FormControl(null, [Validators.required, Validators.min(1), Validators.max(99)]),
      childs: new FormControl(null,  [ Validators.min(0), Validators.max(99)]),
      age_childs: new FormControl(null),
      comment_contact: new FormControl(null, [Validators.minLength(3), Validators.maxLength(500)])
    })

    this.formRentACar.valueChanges.subscribe(() => {
      this.formRentACarEdited = true;
    });

    this.formRentACar.get('childs').valueChanges.subscribe((value: any) => {
      if(value > 0) {
        this.formRentACar.get('age_childs').setValidators(Validators.required);
      } else if (value === 0 || value === '' || value === null) {
         this.formRentACar.get('age_childs').clearValidators();
      }
       this.formRentACar.get('age_childs').updateValueAndValidity();
    });

    this.formRentACar.reset();
    this.formRentACarEdited = false;

      if(this.edit && this.editData) {
        this.patchFormRentACar(this.editData);
    }
  }

  patchFormRentACar(editData: any): void {
      const product = editData?.product || {};
      console.log(product)

      const pickupDate = product.pickupDate
        ? new Date(product.pickupDate)
        : null;

      const dropoffDate = product.dropoffDate
        ? new Date(product.dropoffDate)
        : null;

      this.formRentACar.patchValue({
        origin: product?.origin,
        pickupDate: pickupDate,
        destinationReturn: product.destinationReturn ?? 'N/A',
        dropoffDate: dropoffDate,
        adults: product?.adults,
        childs: product?.childs,
        age_childs: product?.age_childs ?? 'N/A',
        comment_contact: product?.comment_contact ?? 'No hay comentarios'
    });

      if(product?.pickupTimeDay && product?.pickupTimeDay.length > 0){
            product.pickupTimeDay.forEach((meal: any) => {
              let event = {
                target: {
                checked: true,
                value: meal
              }}
              this.onChangeSelectForm(event,'rent-a-car', 'pickupTimeDay');
            })
      }

        if(product?.dropoffTimeDay && product?.dropoffTimeDay.length > 0){
            product.dropoffTimeDay.forEach((meal: any) => {
              let event = {
                target: {
                checked: true,
                value: meal
              }}
              this.onChangeSelectForm(event,'rent-a-car', 'dropoffTimeDay');
            })
      }

        if(product?.vehicleType && product?.vehicleType.length > 0){
            product.vehicleType.forEach((meal: any) => {
              let event = {
                target: {
                checked: true,
                value: meal
              }}
              this.onChangeSelectForm(event,'rent-a-car', 'vehicleType');
            })
      }

        if(product?.transmissionType && product?.transmissionType.length > 0){
            product.transmissionType.forEach((meal: any) => {
              let event = {
                target: {
                checked: true,
                value: meal
              }}
              this.onChangeSelectForm(event,'rent-a-car', 'transmissionType');
            })
      }

       console.log(this.formRentACar)
      this.formRentACar.disable();

  }

  onSubmit(): void {

    const payload: any = {
      client_id: this.userService.clientIdFusion,
      agency_id: this.userService._agencyID,
      agent_id: this.userService._agentID,
      products: {}
    }

    if (this.formHotelEdited) {
      if(this.formHotel.valid) {
        payload.products.hotels = this.buildPayloadHotel();
        const dateRange = payload.products.hotels.arrivalDepartureDate;
        dateRange.start = moment(dateRange.start.toISOString().split('T')[0]).format('YYYY-MM-DD');
        dateRange.end = moment(dateRange.end.toISOString().split('T')[0]).format('YYYY-MM-DD');
      } else {
        this.notificationService.info('Faltan datos en el formulario de hotel');
        return;
      }
    }

    if (this.formTransferEdited) {
      if(this.formTransfer.valid) {
          payload.products.transfers = this.buildPayloadTransfer();
          payload.products.transfers.oneWay = true;
          let pickupDate = payload.products.transfers.firstArrivalDate;
          let dropoffDate = payload.products.transfers?.secondArrivalDate ?? null;
          pickupDate = moment(pickupDate.toISOString().split('T')[0]).format('YYYY-MM-DD');
          if(dropoffDate) {
            dropoffDate = moment(dropoffDate.toISOString().split('T')[0]).format('YYYY-MM-DD');
            payload.products.transfers.oneWay = false;
          }
          payload.products.transfers.firstArrivalDate = pickupDate;
          payload.products.transfers.secondArrivalDate = dropoffDate;
          payload.products.oneWay = this.formTransfer.get('secondArrivalDate').value ? true : false
      } else {
        this.notificationService.info('Faltan datos en el formulario de traslado');
        return;
      }
    }

    if (this.formRentACarEdited) {

      if(this.formRentACar.valid) {
          payload.products.rentacar = this.buildPayloadRentACar();
          console.log(payload.products.rentacar)
          let pickupDate = payload.products.rentacar.pickupDate;
          let dropoffDate = payload.products.rentacar?.dropoffDate ?? null;
          pickupDate = moment(pickupDate.toISOString().split('T')[0]).format('YYYY-MM-DD');
          if(dropoffDate) {
            dropoffDate = moment(dropoffDate.toISOString().split('T')[0]).format('YYYY-MM-DD');
          }
          payload.products.rentacar.pickupDate = pickupDate;
          payload.products.rentacar.dropoffDate = dropoffDate;
      } else {
        this.notificationService.info('Faltan datos en el formulario de rent a car');
        return;
      }
    }


    if(this.formHotelEdited || this.formTransferEdited || this.formRentACarEdited) {
      const dialogRef = this.dialog.open(MaterialModalConfirmComponent, {
        data: {message: 'Crear solicitud', type: 'material'},
        width: '450px'
      });

console.log(JSON.stringify(payload))

      dialogRef.afterClosed().subscribe((result) => {
        if(result) {
          this.spinner.show();
          this.formService.createRequestOffline(payload).subscribe({
            next: (res: any) => {
              this.close();
              this.spinner.hide();
              this.notificationService.success('Su solicitud ha sido registrada con éxito. Pronto alguno de nuestros operadores se pondrá en contacto con usted');
            },
            error: (error: HttpErrorResponse) => {
              this.notificationService.error('Ha ocurrido un error, vuelva a intentarlo más tarde', 'error: ', error.error);
              this.spinner.hide();
            }
          })
        } else {
          this.spinner.hide();
        }
      });

    } else {
      this.notificationService.info('Complete algún formulario para enviar su solicitud');
    }

  }

    buildPayloadHotel(): any {
      const raw = this.formHotel.value;
        if (raw.currency && typeof raw.currency === 'string') {
            raw.currency = raw.currency.toUpperCase();
        }
      return this.cleanPayload(raw);
    }

    buildPayloadTransfer(): any {
      const raw = this.formTransfer.value;
        if (raw.currency && typeof raw.currency === 'string') {
            raw.currency = raw.currency.toUpperCase();
        }
      return this.cleanPayload(raw);
    }

    buildPayloadRentACar(): any {
      const raw = this.formRentACar.value;
        if (raw.currency && typeof raw.currency === 'string') {
            raw.currency = raw.currency.toUpperCase();
        }
      return this.cleanPayload(raw);
    }

    private cleanPayload(obj: any): any {
      const cleaned: any = {};
      for (const key in obj) {
        if (obj[key] !== null && obj[key] !== undefined) {
          cleaned[key] = obj[key];
        }
      }
      return cleaned;
    }

  close(): void {
    this.dialogRef.close();
  }


    startDateClicked($event) {
      console.log($event);
      this.startDate = $event;
      //  this.maxDate = moment($event.startDate._d).add(1, 'month');
    }

    endDateClicked($event: any): void {
      // Convertimos a Day.js las fechas para garantizar consistencia
      const selectedStartDate = dayjs(this.startDate.startDate.$d).startOf('day');
      const selectedEndDate = dayjs($event.endDate.$d).startOf('day'); // Normaliza al inicio del día

      console.log('Fecha de inicio:', selectedStartDate.toISOString());
      console.log('Fecha de fin:', selectedEndDate.toISOString());

      // Validar si la fecha de fin es inválida, igual o anterior a la fecha de inicio
      if (!selectedEndDate.isValid() || selectedEndDate.isSame(selectedStartDate) || selectedEndDate.isBefore(selectedStartDate)) {

        this.notificationService.warning('Debe elegir mínimo un día de diferencia con el día de inicio');


        this.formHotel.get('arrivalDate')?.setValue(null); // Limpia el campo en el formulario

        setTimeout(() => {
          this.picker.clear(); // Limpia cualquier selección previa del datePicker
          this.picker.open(); // Reabre el calendario para seleccionar una nueva fecha
          // Resetea el rango de fechas y el formulario
        }, 100);
      } else {
        this.dateRange = { start: selectedStartDate, end: selectedEndDate };
        console.log('Rango de fechas válido:', { start: selectedStartDate, end: selectedEndDate });
      }
    }

    capitalize(val: any) {
      if(val !== undefined && val !== null) {
        return val
          .toLowerCase()
          .trim()
          .split(" ")
          .map((v) => v[0].toUpperCase() + v.substr(1))
          .join(" ");
      }
    }

    /**
 * Método para intercambiar las ubicaciones de origen y destino.
 *
 * Este método intercambia los valores de origen y destino en el formulario. Los valores se toman de los campos
 * `firstOrigin` y `firstDestination` y luego se aplican en el formulario usando `patchValue`.
 */
swapLocations() {
  // Intercambiar valores del formulario
  const origin = this.formTransfer.get('firstOrigin')?.value;
  const destination = this.formTransfer.get('firstDestination')?.value;

  this.formTransfer.patchValue({
    firstOrigin: destination,
    firstDestination: origin
  });

  // Intercambiar pickup y dropoff
  const tempPickup = this.pickup;
  this.pickup = this.dropoff;
  this.dropoff = tempPickup;

  // Intercambiar códigos IATA
  const tempIata = this.selectediataCodeOrigin;
  this.selectediataCodeOrigin = this.selectediataCodeDestiny;
  this.selectediataCodeDestiny = tempIata;

  // Intercambiar los valores visuales de los inputs
  const tempInputValue = this.originInputValue;
  this.originInputValue = this.destinationInputValue;
  this.destinationInputValue = tempInputValue;
}

/**
 * Método para manejar el cambio de fecha.
 *
 * Este método se utiliza para establecer la fecha de llegada en el formulario y la hora actual,
 * o para restablecer la fecha si el valor es `null`.
 *
 * @value -> valor de tipo Date que representa la nueva fecha de llegada seleccionada.
 */
onDateChange(value: Date | null) {
  if (value) {
    this.oneWay = false;
    this.formTransfer.get('secondArrivalDate').setValue(value);
    this.formTransfer.get('secondTime').setValue(this.currentTime);
  } else {
    this.formTransfer.get('secondArrivalDate').setValue(null);
  }
}

onChangeSelectForm(event: any, form: string, control: string): void {
console.log(event)
  let controlForm;
  switch(form) {
    case 'hotel':
      controlForm = this.formHotel.get(`${control}`) as FormArray;
      break;
    case 'transfer':
      controlForm = this.formTransfer.get(`${control}`) as FormArray;
      break;
    case 'rent-a-car':
      controlForm = this.formRentACar.get(`${control}`) as FormArray;
      break;
  }

  if (event.target.checked) {
    controlForm.push(new FormControl(event.target.value));
  } else {
    const index = controlForm.controls.findIndex(ctrl => ctrl.value === event.target.value);
    if (index !== -1) {
      controlForm.removeAt(index);
    }
  }
}

resetForm(type): void {
  switch(type) {
    case 'hotel':
      // this.initFormHotel();
      this.formHotel.reset();
      this.formHotelEdited = false;
    break;
    case 'transfer':
      // this.initFormHotel();
      this.formTransfer.reset();
      this.formTransferEdited = false;
    break;
    case 'rent-a-car':
      // this.initFormHotel();
      this.formRentACar.reset();
      this.formRentACarEdited = false;
    break;
  }
}

fixCalendarPosition(): void {
  if(this.picker) {
    this.picker.open();

    setTimeout(() => {
      const pickerElement = document.querySelector('ngx-daterangepicker-material') as HTMLElement;
      const inputElement = document.querySelector('.input-ngxDateRangePicker') as HTMLElement;

      if (pickerElement && inputElement) {
        const inputRect = inputElement.getBoundingClientRect();
        const pickerRect = pickerElement.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;

        // Posición FIJA a la derecha del input
        let rightPosition = inputRect.left + window.scrollX + 5; // 5px de margen
        let topPosition = inputRect.top + window.scrollY;

        // Verificar si cabe a la derecha, si no, ajustar al borde derecho
        if (rightPosition + pickerRect.width > viewportWidth) {
          rightPosition = viewportWidth - pickerRect.width - 10; // 10px de margen del borde
        }

        // Verificar posición vertical - asegurar que no se salga
        if (topPosition + pickerRect.height > viewportHeight) {
          topPosition = viewportHeight - pickerRect.height - 10; // Alinear con parte inferior
        }

        // Aplicar estilos para posición fija a la derecha
        pickerElement.style.position = 'fixed';
        pickerElement.style.top = `${topPosition}px`;
        pickerElement.style.right = `${rightPosition}px`;
        pickerElement.style.transform = 'none';
        pickerElement.style.zIndex = '99999';
        pickerElement.style.margin = '0';
      }
    }, 0);
  }
}
adjustPickerPosition(pickerElement: HTMLElement, inputRect: DOMRect) {
  const pickerRect = pickerElement.getBoundingClientRect();
  const viewportHeight = window.innerHeight;
  const viewportWidth = window.innerWidth;

  // Ajuste vertical (si no cabe abajo, mostramos arriba)
  if (pickerRect.bottom > viewportHeight) {
    pickerElement.style.top = `${inputRect.top + window.scrollY - pickerRect.height}px`;
  }

  // Ajuste horizontal (si no cabe a la derecha, alineamos a la izquierda)
  if (pickerRect.right > viewportWidth) {
    pickerElement.style.left = `${viewportWidth - pickerRect.width - 10}px`;
  }
}

limitNumber(event: KeyboardEvent, max: number) {
    const input = event.target as HTMLInputElement;
    const value = input.value + event.key;

  if (Number(value) > max) {
    event.preventDefault();
  }
}

     /**
   * Bloquea la entrada de caracteres no deseados (`e`, `E`, `+`, `-`) en campos numéricos.
   * @param event El evento de teclado.
   */
blockInvalidKeys(event: KeyboardEvent, input?: string) {
    const key = event.key;

    switch (input) {
        case 'name':
            // Permitir teclas especiales: Backspace, Delete, Tab, Escape, Enter, y las flechas
            if (
              [
                'Backspace',
                'Delete',
                'Tab',
                'Escape',
                'Enter',
                'ArrowLeft',
                'ArrowRight',
              ].includes(key)
            ) {
              return; // Permitir estas teclas
            }

            // Bloquear caracteres que no coincidan con letras, acentos, ñ o espacios
            if (!/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]$/.test(key)) {
              event.preventDefault();
            }
            break;

        case 'number':
            if (['e', 'E', '+', '-', ',', '.'].includes(key)) {
                event.preventDefault();
              }
            break;
        case 'price':
            if (['e', 'E', '+', '-',].includes(key)) {
                event.preventDefault();
              }
            break;

        case 'age_childs':
             // Permitir teclas especiales: Backspace, Delete, Tab, Escape, Enter, y las flechas
                if (
                    [
                        'Backspace',
                        'Delete',
                        'Tab',
                        'Escape',
                        'Enter',
                        'ArrowLeft',
                        'ArrowRight',
                        'Home',
                        'End'
                    ].includes(key)
                ) {
                    return; // Permitir estas teclas
                }

                // Permitir números (0-9), comas y espacios
                if (!/^[0-9,\s]$/.test(key)) {
                    event.preventDefault();
                }
            break;
            case 'currency':
            // Permitir teclas especiales: Backspace, Delete, Tab, Escape, Enter, y las flechas
            if (
                [
                    'Backspace',
                    'Delete',
                    'Tab',
                    'Escape',
                    'Enter',
                    'ArrowLeft',
                    'ArrowRight',
                    'Home',
                    'End',
                    ' '
                ].includes(key)
            ) {
                return; // Permitir estas teclas
            }

            // Permitir letras (A-Z, a-z) y comas
            if (!/^[a-zA-Z,]$/.test(key)) {
                event.preventDefault();
            }
            break;
                }
      }

      /**
 * Limita los decimales a máximo 2 después del punto/coma
 */
limitDecimals(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    // Reemplazar coma por punto para consistencia
    value = value.replace(',', '.');

    // Verificar si tiene decimales
    if (value.includes('.')) {
        const parts = value.split('.');

        // Si hay más de 2 decimales, truncar a 2
        if (parts[1] && parts[1].length > 2) {
            parts[1] = parts[1].substring(0, 2);
            value = parts[0] + '.' + parts[1];
        }

        // Actualizar el valor
        input.value = value;
    }
}

/**
 * Formatea automáticamente el input de currency después de escribir 3 letras
 * @param event El evento de input
 */
formatCurrencyInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const cursorPosition = input.selectionStart;
    let value = input.value.toUpperCase().replace(/[^A-Z,]/g, '');

    // Dividir por comas y procesar cada parte
    const parts = value.split(',');

    // Filtrar partes vacías y limpiar cada parte (máximo 3 caracteres)
    const cleanedParts = parts.map(part => part.replace(/[^A-Z]/g, '').substring(0, 3));

    // Reconstruir el valor uniendo con comas + ESPACIO
    value = cleanedParts.join(', '); // <- Cambio aquí

    // Solo agregar coma + ESPACIO automáticamente si:
    // - La última parte tiene exactamente 3 caracteres
    // - No estamos borrando (el nuevo valor es más largo que el anterior)
    // - No está ya seguido de una coma
    const lastPart = cleanedParts[cleanedParts.length - 1];
    if (lastPart.length === 3 &&
        value.length > input.value.length &&
        !value.endsWith(',')) {
        value += ', '; // <- Cambio aquí también
    }

    // Actualizar el valor
    input.value = value;

    // Ajustar la posición del cursor
    if (cursorPosition !== null) {
        const newPosition = Math.min(cursorPosition, value.length);
        input.setSelectionRange(newPosition, newPosition);
    }
}
}
